import React from "react";
import PropsUtils from "src/engineEditor/props/utils/PropsUtils";

import { SourceContext, ISourceContext } from "src/engine/SourceCenter/SourceContext";
import ExecScript from "./ExecScript";
import PageContext, { IPageContext } from "src/engine/pages/ui/PageContext";
import { IMMEDIATE_SCRIPT_FLAG, MOUNTED_IMMEDIATE_SCRIPT_FLAG, UNMOUNT_IMMEDIATE_SCRIPT_FLAG } from "src/lib/utils/Const";

interface ILifeCycle {
    componentWillUnmount?: () => {};
    componentDidMount?: () => {};
    init?: () => {};
}

/**
 *
 *
 * @class GGProps
 */
const GGProps = (ggProps: string[]) => {
    return (Comp: any) => {
        return class UI extends React.Component {
            checkList: string[];

            static type = "GGProps";

            sourceContext: ISourceContext;

            pageContext: IPageContext;

            lifeCycle: ILifeCycle = {};

            state = {
                props: {},
            };

            constructor(props: any) {
                super(props);
                this.checkList = [];
                this.state = { props: this.getGGState(props) };
                this.immediateExec(IMMEDIATE_SCRIPT_FLAG);
            }

            immediateExec(type: string = IMMEDIATE_SCRIPT_FLAG) {
                const immeProps = this.state.props[type];
                if (immeProps && typeof immeProps === "function") {
                    const { info = {} } = (this.props as any).uiItem || {};
                    console.log(`[${type}] 执行脚本 , ename: ${info.ename} cname: ${info.cname}`);
                    immeProps();
                }
            }

            componentWillUnmount() {
                this.immediateExec(UNMOUNT_IMMEDIATE_SCRIPT_FLAG);
            }

            componentDidMount() {
                // 渲染完成后执行脚本
                this.immediateExec(MOUNTED_IMMEDIATE_SCRIPT_FLAG);
            }

            updateUI(state: any = {}) {
                state._count = (this.state as any)._count || 1;
                state._count += 1;
                if (state.props) {
                    state.props = { ...this.state.props, ...state.props };
                }
                this.setState(state);
            }

            setLifecycle(cycle: ILifeCycle) {
                Object.keys(cycle).forEach((key: string) => {
                    this.lifeCycle[key] = cycle[key];
                });
            }

            getGGState(props: any) {
                let state = {};
                this.checkList = [];
                ggProps.map((ggProp) => {
                    this.checkList.push(ggProp);
                    if (props[ggProp]) {
                        if (props[ggProp].endKey) this.checkList.push(props[ggProp].endKey);
                        const ret = new ExecScript(props[ggProp] || {}, this, props).exec();
                        if (Object.keys(this.lifeCycle).length > 0) {
                            state = { ...state, ...ret, lifeCycle: this.lifeCycle };
                        } else {
                            state = { ...state, ...ret };
                        }
                    }
                });

                return state;
            }

            UNSAFE_componentWillReceiveProps(nextProps: any) {
                for (const item of this.checkList) {
                    if (PropsUtils.getValue(nextProps, item) !== PropsUtils.getValue(this.props, item)) {
                        this.setState({ props: this.getGGState(nextProps) });
                        return;
                    }
                }
            }

            render() {
                const { ggValue, setProps, ...other } = this.props as any;

                // console.log('[GGProps]:setProps', setProps);
                // const props = { ...other, ...this.state.props };
                setProps?.(other, { ...this.state.props });

                return [
                    <SourceContext.context.Consumer key={0}>
                        {(context: ISourceContext) => {
                            this.sourceContext = context;
                            return null;
                        }}
                    </SourceContext.context.Consumer>,
                    <PageContext.context.Consumer key={1}>
                        {(context: IPageContext) => {
                            this.pageContext = context;
                            return null;
                        }}
                    </PageContext.context.Consumer>,
                    <Comp key={2} {...other} {...this.state.props} />,
                ];
            }
        };
    };
};

export default GGProps;
